import { Component, effect, ElementRef, EventEmitter, Input, OnInit, Output, Signal, signal } from '@angular/core';

import { MapComponent } from '../map.component';
import { TranslateModule } from '@ngx-translate/core';
import { QPointIconModule } from '@qpoint/icons';
import { NgIf } from '@angular/common';

export enum MapTypeEnum {
  Hybrid = 'hybrid', // Satellite view with roads
  Roadmap = 'roadmap'
}

@Component({
    selector: 'qpoint-map-type-control',
    templateUrl: './map-type-control.component.html',
    styleUrls: ['./map-type-control.component.scss'],
    imports: [NgIf, QPointIconModule, TranslateModule]
})
export class MapTypeControlComponent implements OnInit {
  mapTypeEnum = MapTypeEnum;

  @Input() closePopupSignal: Signal<boolean>;
  @Output() closeOtherPopups = new EventEmitter<boolean>();
  @Input() mapComponent: MapComponent;
  @Input() roadmapLabel: string;
  @Input() hybridLabel: string;
  @Input() mapTypeLabel: string;

  activeMapType = signal<string>(null);
  mapTypeSelectionPopupVisible = signal<boolean>(false);
  readonly googleMapsButtonHeight = 32;

  @Output() mapTypeChanged = new EventEmitter<string>();

  constructor(private hostElement: ElementRef<HTMLElement>) {
    if (this.closePopupSignal) {
      effect(() => {
        if (this.closePopupSignal()) {
          this.closeMapTypeSelectionPopup();
        }
      });
    }
  }

  ngOnInit() {
    this.activeMapType.set(this.mapComponent.map.googleMap.getMapTypeId());
  }

  lastSpacerExists() {
    return this.getBackDropHeight() >= this.googleMapsButtonHeight * 2;
  }

  getBackDropHeight() {
    const host = this.hostElement.nativeElement;
    const hostRect = host.getBoundingClientRect();
    if (this.mapComponent.isZoomAndMapTypeSamePosition()) {
      const parent = host.parentElement.parentElement;
      const parentRect = parent.getBoundingClientRect();
      const distance = parentRect.bottom - hostRect.bottom + hostRect.height;
      return distance;
    }
    if (this.mapComponent.enableFullscreenControl) {
      return this.googleMapsButtonHeight * 2;
    }
    return this.googleMapsButtonHeight;
  }

  toggleMapTypeSelectionPopup($event?: MouseEvent) {
    $event?.preventDefault();
    this.mapTypeSelectionPopupVisible.set(!this.mapTypeSelectionPopupVisible());
    this.closeOtherPopups.emit(true);
  }

  closeMapTypeSelectionPopup() {
    this.mapTypeSelectionPopupVisible.set(false);
  }

  setRoadmapType($event: MouseEvent) {
    $event.preventDefault();
    this.mapTypeChanged.emit(MapTypeEnum.Roadmap);
    this.mapComponent.map.googleMap.setMapTypeId(MapTypeEnum.Roadmap);
    this.activeMapType.set(this.mapComponent.map.googleMap.getMapTypeId());
    this.toggleMapTypeSelectionPopup();
  }

  setHybridType($event: MouseEvent) {
    $event.preventDefault();
    this.mapTypeChanged.emit(MapTypeEnum.Hybrid);
    this.mapComponent.map.googleMap.setMapTypeId(MapTypeEnum.Hybrid);
    this.activeMapType.set(this.mapComponent.map.googleMap.getMapTypeId());
    this.toggleMapTypeSelectionPopup();
  }
}
